module.exports = __webpack_public_path__ + "img/collection-weddingRingsSlim.b9384b5.webp";